import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ClassificationRequestDto } from 'src/api/FiretrolApiClient';
import { classificationApiClient } from 'src/api/FiretrolApiClientInstances';
import { invalidateFor } from 'src/api/queries/invalidationMap';

export function useCreateClassification() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (request: ClassificationRequestDto) =>
      classificationApiClient.create(request),
    meta: { suppressErrorToast: true },
    onSettled: () => invalidateFor('classification.save', qc),
  });
}

export function useUpdateClassification() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({
      id,
      request,
    }: {
      id: string;
      request: ClassificationRequestDto;
    }) => classificationApiClient.update(id, request),
    meta: { suppressErrorToast: true },
    onSettled: () => invalidateFor('classification.save', qc),
  });
}

export function useDeleteClassification() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => classificationApiClient.delete(id),
    meta: { suppressErrorToast: true },
    onSettled: () => invalidateFor('classification.save', qc),
  });
}
